import Chart from "chart.js";
import axios from "axios";
export function SekolahChart() {
  let dashboardUrl = "seller/dashboard";
  axios
    .get(dashboardUrl)
    .then((response) => {
      return response.data.data.chartStatistic.popularSchool;
    })
    .then((data) => {
      var ctx = document.getElementById("sekolahPopulerChart").getContext("2d");
      //  var sekolahName = `{{App\ChartModel::sekolahPopuler()}}`;
      var resSekolahName = data.label;
      // .replace('[&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;]', '')
      // .replace(']', '')
      // .split(",");

      // var sekolahData = `{{App\ChartModel::sekolahPopulerData()}}`;
      var resSekolahData = data.value;
      // .replace('[&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;', '')
      // .replace('&quot;', '').replace('&quot;]', '')
      // .replace(']', '').split(",");

      let gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
      gradientFill.addColorStop(0, "#F2F7F8");
      gradientFill.addColorStop(1, "#BDB7B3");

      new Chart(ctx, {
        type: "line",
        data: {
          labels: resSekolahName,
          datasets: [
            {
              lineTension: 0,
              label: "Qty",
              data: resSekolahData,
              backgroundColor: gradientFill,
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                barPercentage: 1,
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  display: resSekolahData[2] == "null" ? true : false,
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
              },
            ],
          },
          maintainAspectRatio: true,
          legend: {
            display: false,
            position: "bottom",
          },
          tooltips: {
            bodySpacing: 1,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
            xPadding: 10,
            yPadding: 10,
            caretPadding: 10,
          },
        },
      });
    });
}
